import React from "react"
import Papa from "papaparse"
import { PCDLoader } from "three-stdlib";
import { useLoader } from "@react-three/fiber";
import { BufferGeometry, Group, Material, Points } from "three";
import { MetadataDict } from "./types";



export const useMetadata = () =>{
    const [metadata, setMetadata] = React.useState<MetadataDict | undefined>(undefined);

    React.useEffect(()=>{
        fetch( './CerebrA_LabelDetails.csv' )
        .then( response => response.text() )
        .then( responseText => {
            var data = Papa.parse(responseText);
            let newMetadata:MetadataDict = {}
            data.data.slice(1).forEach((row:any)=>{
                if(row[2]){
                    newMetadata[row[2]] = {
                        id: parseInt(row[2]),
                        mindboggleId: parseInt(row[0]),
                        resourceId: isNaN(parseInt(row[6]))?undefined: parseInt(row[6])+ 6,
                        name: row[1],
                        isRightHemisphere: false,
                        isCortex: parseInt(row[0]) > 1000
                    }
    
                    newMetadata[row[3]] = {
                        id: parseInt(row[3]),
                        mindboggleId: parseInt(row[0]),
                        resourceId: isNaN(parseInt(row[6]))?undefined: parseInt(row[6]) ,
                        name: row[1],
                        isRightHemisphere: true,
                        isCortex: parseInt(row[0]) > 1000
                    }
                }
                
            })
            setMetadata(newMetadata);
        })
    },[])

    return metadata
}

export function usePCD(path: string): Points<BufferGeometry, Material | Material[]> {
    return useLoader(PCDLoader, path);
  }
  
  usePCD.preload = (path: string) => useLoader.preload(PCDLoader, path);
  usePCD.clear = (input: string | string[]) => useLoader.clear(PCDLoader, input);